// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lb-0";
export var assigneeDetails = "_lb-1";
export var assigneeInfo = "_lb-2";
export var dropdownContainer = "_lb-4";
export var dropdownImage = "_lb-5";
export var editAssigneeInfo = "_lb-3";
export var editAssigneeModalContainer = "_lb-6";
export var hidden = "_lb-8";
export var input = "_lb-7";